import React from "react";

export default function ConcreteMixerIcon({
  size = 65,
  color = "#C73A33"
}) {
  return (
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      width={size} height={size} viewBox="0 0 512 512"
      preserveAspectRatio="xMidYMid meet">

      <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill={color} stroke="none">
        <path d="M967 4700 c-130 -13 -280 -37 -391 -65 -161 -40 -133 13 -366 -695
-109 -333 -201 -621 -205 -640 -8 -49 14 -114 80 -231 259 -457 682 -729 1175
-755 96 -5 109 -4 150 18 33 17 51 35 68 68 28 56 28 96 -1 150 -32 62 -89 90
-177 90 -134 0 -305 42 -438 108 -194 96 -384 285 -501 497 l-22 40 173 520
173 520 90 17 c311 57 630 46 935 -32 264 -67 573 -227 778 -402 41 -35 88
-71 105 -80 85 -47 201 7 225 105 6 21 9 44 7 51 -2 6 -6 23 -9 38 -9 38 -53
86 -154 166 -330 262 -709 427 -1130 492 -146 23 -434 33 -565 20z"/>
        <path d="M3147 4236 c-42 -15 -73 -40 -90 -71 -6 -11 -162 -459 -347 -995
l-337 -975 -894 -5 -894 -5 -37 -23 c-21 -13 -45 -40 -57 -66 -20 -40 -21 -58
-21 -417 0 -369 0 -375 23 -419 60 -120 233 -118 288 4 17 37 19 70 19 318 l0
278 868 2 c852 3 868 3 902 23 19 12 43 35 53 52 32 55 737 2111 737 2149 0
108 -113 187 -213 150z"/>
        <path d="M3420 3738 c-31 -16 -51 -36 -67 -67 l-23 -44 0 -663 c0 -445 4 -672
11 -691 13 -35 45 -70 84 -91 27 -15 87 -17 520 -20 270 -2 513 0 542 3 96 12
157 77 156 166 -1 60 -29 107 -81 137 -39 22 -44 22 -471 22 l-431 0 0 470 0
470 324 0 323 0 81 -172 c160 -344 301 -715 363 -956 l39 -153 0 -322 c0 -181
4 -337 10 -356 13 -47 66 -99 113 -112 75 -20 153 15 186 85 20 40 21 59 21
360 0 176 -5 349 -11 389 -41 277 -223 788 -438 1232 -114 236 -150 291 -204
315 -39 18 -71 20 -522 20 -479 0 -481 0 -525 -22z"/>
        <path d="M3094 2046 c-17 -8 -43 -29 -58 -48 -50 -67 -47 -145 10 -208 47 -52
101 -64 276 -58 126 3 138 5 175 30 98 65 98 199 0 272 -26 19 -44 21 -200 23
-130 2 -180 -1 -203 -11z"/>
        <path d="M1420 1704 c-179 -38 -356 -177 -437 -344 -172 -352 -15 -760 348
-903 331 -131 723 45 845 378 l22 60 600 3 600 2 12 -37 c61 -188 226 -352
421 -417 69 -23 103 -28 189 -29 126 -2 187 12 300 65 142 68 289 234 330 375
l13 41 171 4 c158 3 174 5 208 26 42 26 78 92 78 143 0 49 -39 110 -85 136
-37 21 -52 23 -206 23 l-166 0 -13 43 c-46 154 -182 308 -337 382 -189 90
-417 83 -597 -18 -140 -78 -254 -213 -300 -355 l-18 -52 -600 2 -601 3 -18 53
c-54 160 -191 305 -354 377 -116 52 -276 67 -405 39z m265 -335 c67 -25 141
-94 175 -164 21 -42 25 -64 25 -140 0 -78 -4 -97 -28 -142 -35 -68 -89 -120
-157 -152 -78 -37 -191 -37 -270 0 -140 67 -218 228 -181 376 25 97 112 192
209 228 57 21 162 18 227 -6z m2490 -11 c53 -27 123 -95 148 -144 28 -54 40
-146 28 -205 -52 -242 -319 -348 -514 -204 -200 148 -162 464 69 561 80 34
194 30 269 -8z"/>
      </g>
    </svg>
  )
}